<template>
    <div class="topbar-container">
        <div class="scrollbar-container">
            <div class="line"></div>
            <div class="problemList-list fold">
                <van-collapse
                    v-model="activeNames"
                    v-for="(item,i) in  problemList"
                    :key="i"
                    accordion
                >
                    <van-collapse-item :name="i" class="fz_30">
                        <template #title>
                            <div class="item bh bstart b1 fz_34">
                                <div class="ico-Q bg-contain"></div>
                                {{item.name}}
                                <div
                                    class="hot"
                                    v-if="item.name === '什么是车主币？' || item.name === '车主币提现额度？'"
                                >
                                    <div class="hotsj"></div>
                                    <div class="hottext fz_22 c_white r4">热门</div>
                                </div>
                            </div>
                        </template>
                        <div class="text1 bh b1 fz_28">
                            <div class="ico-A bg-contain"></div>
                            <div clasa="title">{{item.value}}</div>
                        </div>
                        <ul
                            type="circle"
                            class="text2"
                            v-for="(title,index) in item.text"
                            :key="index"
                        >
                            <li type="disc" class="fz_28">{{title}}</li>
                        </ul>
                    </van-collapse-item>
                </van-collapse>
            </div>
        </div>
    </div>
</template>
<script>
import { user } from "@/mixin/user";
export default {
    mixins: [user],
    name: "CommonProblem",
    data() {
        return {
            activeNames: ["1"],
            problemList: [
                {
                    name: "什么是车主币？",
                    value:
                        "车主币是用户在系统里的虚拟币，支持提现，支付等功能。",
                    text: [
                        "提现：将车主币虚拟币转到储蓄卡。",
                        "支付：可以用车主币购买商品和服务。"
                    ]
                },
                {
                    name: "车主币提现额度？",
                    value: "车主币提现有最低和最高提现额度。",
                    text: [
                        "最低提现额度：单次最低提现额度为100车主币。",
                        "最高提现额度：自然月内最高提现额度为10w车主币。"
                    ]
                },
                {
                    name: "哪些证件可以实名认证？",
                    value: "实名认证有证件类型限制。",
                    text: ["证件类型：目前支持的证件类型为身份证。"]
                },
                {
                    name: "可以绑定几张银行卡？",
                    value: "绑定银行卡数量限制。",
                    text: ["银行卡数量：支持用户最多绑定银行卡6张。"]
                },
                {
                    name: "提现后多久可以到账？",
                    value: "申请提现后一般为1-3个工作日到账。",
                    text: [
                        "提现到账时间：为保证资金安全，正常情况下我们承诺1-3个工作日内到账，请耐心等待。如果超出3个工作日，请首先确认交易记录状态，并进入交易记录详情页确认是否提现成功。"
                    ]
                },
                {
                    name: "提现成功，银行卡未到账怎么办？",
                    value: "提现成功，银行卡未到账请与客服联系。",
                    text: [
                        "处理方式：发起提现后，显示到账但银行卡没有收到钱，请先登录银行卡网银查询，部分银行对于小额的入账不会发送短信提醒，部分银行需要订阅短信提醒服务后才能提供到账提醒。如果网银未查询到记录，请将用户名、电话号码和银行卡号反馈给客服排查。"
                    ]
                },
                {
                    name: "支持提现的银行名称？",
                    value: "目前除以下18家银行外，其他银行暂不支持。",
                    text: [
                        "目前系统支持提现的银行有中国工商银行、中国银行、中国农业银行、招商银行、中国建设银行、交通银行、中信银行、中国光大银行、华夏银行、中国民生银行、广发银行、平安银行、兴业银行、浦发银行、北京银行、上海银行、中国邮政银行、恒丰银行共18家银行。"
                    ]
                }
            ]
        };
    }
};
</script>

<style scoped lang="scss">
@include ico-list("~@/assets/imges/ico/", "compDown", "Q", "A");
.scrollbar-container {
    background-color: #f1f2f3;
}
.ico-Q {
    width: 32px;
    height: 32px;
    margin-right: 12px;
}

.item {
    padding: 15px 0 15px 0;
}
.hot {
    position: relative;
    .hotsj {
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 12.5px 20px 12.5px 0;
        border-color: transparent #FF9A2B transparent transparent;
        position: absolute;
        bottom: 10px;
        left: -2px;
    }
    .hottext {
        padding: 0 8px;
        background-color: #FF9A2B;
        margin-left: 10px;
        margin-top: -3px;
    }
}

/deep/ .van-cell__right-icon {
    margin-top: 17px;
}
.text1 {
    .ico-A {
        width: 32px;
        height: 32px;
        margin-right: 12px;
        margin-top: 4px;
    }
}
.text2 {
    padding-left: 73px;
}
</style>

